import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Risultati reali" className="border-y border-grape/10 bg-white/70" data-id="element-173" data-mp="2wxqc25ic86f9">
      <div className="mx-auto max-w-5xl px-5 py-8" style={{
      paddingTop: "13px",
      paddingBottom: "14px"
    }} data-id="element-174" data-mp="2wvdv9vobg23s">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-175" data-mp="2nx1y1asy262d">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-176" data-mp="2nz4xsmjwfdka">
              <dt className="font-display text-4xl font-black text-plum sm:text-5xl" data-id="element-177" data-mp="29732lfsrx8ql">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-plum/60" data-id="element-178" data-mp="2dzw6k1gf4d1m">{s.label}</dd>
            </div>)}
        </dl>
        
      </div>
    </section>;
}